import { AgencyProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface IAgencyProps {
  id?: string
  name: string | null
  kana: string | null
  createdAt: string | null
  updatedAt: string | null
  properties: AgencyProperties | null
}

export default class AgencyEntity {
  private _props: IAgencyProps

  constructor(props?: IAgencyProps | null) {
    this._props = EmptyAgencyPropsFactory(props)
  }

  get props(): IAgencyProps {
    return this._props
  }

  get clone(): IAgencyProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get name(): string | null {
    return this._props.name
  }

  get kana(): string | null {
    return this._props.kana
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get properties(): AgencyProperties | null | undefined {
    return this._props.properties
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyAgencyPropsFactory = (props?: Partial<IAgencyProps> | null): IAgencyProps => ({
  name: null,
  kana: null,
  createdAt: null,
  updatedAt: null,
  properties: null,
  ...props
})
